import React from "react";
import choose1 from "../assets/choose_1.png";
import choose2 from "../assets/choose_2.png";
import choose3 from "../assets/choose_3.png";

function ChooseUs() {
  const services = [
    {
      title: "Fast – Speed That Saves You Time",
      description:
        "Get things done quicker with our fast service. From instant bookings to prompt deliveries, we make speed a priority — so you can move forward without delays.",
      img: choose1
    },
    {
      title: "Affordable – Quality Service Within Your Budget",
      description:
        "Our affordable charges ensure you get the best value for your money, whether you're booking a taxi, sending a parcel, or using any of our services.",
      img: choose2
    },
    {
      title: "Reliable – Count on Us, Every Time",
      description:
        "We pride ourselves on being reliable — always on time, always dependable. Whether you're booking a ride or sending a parcel, you can trust us to deliver with consistency, safety, and care.",
      img: choose3
    }
  ];

  return (
    <div className="container my-5 text-center">
      <h3 className="fw-bold">Why Choose Us</h3>
      <p className="text-warning fs-5">
        We Are Dedicated To Provide Quality Service
      </p>
      <span>
        There are many variation of passages availablebut the majority have
        suffered altration in some form going to use a passage by injected
        humours randomised words which don't look even slightly believable.
      </span>

      <div className="row g-4 mt-5">
        {services.map((service, index) =>
          <div className="col-12 col-md-4" key={index}>
            <div
              className="p-3 h-100 rounded"
              style={{
                border: "1px solid #FCB027",
                background: "#1D1D1B",
                color: "#F4F4F4"
              }}
            >
              <img
                src={service.img}
                alt={service.title}
                className="mb-3"
                style={{ width: "80px", height: "80px" }}
              />
              <p style={{ color: "#FCB027" }}>
                {service.title}
              </p>
              <p className=" small">
                {service.description}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChooseUs;
